<template>
  <div class="flex flex-col gap-1">
    <div class="flex items-center flex-wrap gap-1 p-2 bg-body-gray border border-common-border rounded-md">
      <CalculatedColumnElement
        v-for="(element, index) in elements"
        :key="index"
        :element
        :fields
        :disabled
        :is-in-parentheses
        :is-last-element="index === elements.length - 1"
        @update="handleUpdateExpression(index, $event)"
        @close-parentheses="handleCloseParentheses"
      />
      <span
        v-if="!modelValue"
        class="text-xs text-gray-500"
      >
        Please select fields, enter numbers, and use the operation buttons below to build your custom formula.
      </span>
    </div>
    <CalculatedColumnActions
      v-model="modelValue"
      v-model:is-in-parentheses="isInParentheses"
      :fields
      :disabled
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { CalculatedColumn } from '@types'
import { GridColumn } from '@/components/UI/Grid/utils/types'

import CalculatedColumnActions from './CalculatedColumnActions.vue'
import CalculatedColumnElement from './CalculatedColumnElement.vue'

type Props = {
  disabled?: boolean
  fields: GridColumn[]
}

const { fields } = defineProps<Props>()

const modelValue = defineModel<CalculatedColumn['expression']>({ default: '' })

defineOptions({
  name: 'UICalculatedColumn',
  inheritAttrs: false,
})

const isInParentheses = ref(false)

const elements = computed({
  get() {
    return modelValue.value?.split(' ') || []
  },
  set(value) {
    modelValue.value = value.join(' ')
  }
})

const handleUpdateExpression = (index: number, element: CalculatedColumn['expression']) => {
  elements.value = elements.value.map((e, i) => i === index ? `${element}` : e)
}

const handleCloseParentheses = () => {
  isInParentheses.value = false
}
</script>
